import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/insights/[slug]/components/BlogPostView.tsx");
